import React from 'react';
import { useRecoilValue } from 'recoil';
import { getDownloadLink } from '../../Shares/CommonUtil';
import { cdnUrlConfig } from '../../Utils/atoms';

const InteriorItemPromotion = () => {
	const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;

	return (
		<div id='wrap'>
			<div className='container'>
				<div className='content Interior Promotion'>
					{/* 비주얼 */}
					<div className='visual'>
						<h1>
							<img
								src={`${IMG_URL}/images/interior-item-purchase/tit.png`}
								alt='비글즈 1주년기념 Event 인테리어 사면 하트가 팡팡팡!'
							/>
						</h1>
						<i></i>
					</div>

					{/* 경품소개 */}
					<div className='event-info product'>
						<div className='tit-area'>
							<h2>
								매주 인테리어 <strong>소품 5개</strong> 사고
								<br />
								최대{' '}
								<span>
									<i></i> 400
								</span>
								개까지
								<br />
								받아가세요!
							</h2>
						</div>
					</div>

					{/* 참여방법 */}
					<div className='event-info howto'>
						<div className='content'>
							<div className='tit-area'>
								<h2>참여방법</h2>
							</div>
							<ol>
								<li>
									매주 인테리어 아이템을 <strong>5개 이상</strong> 구매한다.
								</li>
								<li>
									미션 성공 후 ‘선물함’에서 하트 <strong>100개씩</strong> 획득!
								</li>
							</ol>
							<p>상품은 주차마다 종료 후 그 다음날 일괄 지급됩니다.</p>
						</div>
					</div>

					{/* 이벤트기간 */}
					<div className='event-info term'>
						<div className='content'>
							<div className='tit-area'>
								<h2>참여방법</h2>
							</div>
							<p>2023년 06월 05일 (월) ~ 07월 02일 (일)</p>
						</div>
					</div>

					{/* 주의사항 */}
					<div className='cautionary'>
						<dl>
							<dt>확인해주세요</dt>
							<dd>
								이벤트 참여 및 보상 오류는 고객센터 1:1 로 문의주세요.
								<br />
								*비글즈 어플 &gt; 마이페이지 &gt; 설정 &gt; 고객센터 &gt; 1:1
								문의
							</dd>
							<dd>
								구매 외 다른 방법으로 얻은 인테리어 소품은 제외되어 계산됩니다.
								(ex. 선물상자)
							</dd>
							<dd>상품은 주차마다 종료 후 그 다음날 일괄 지급됩니다.</dd>
							<dd>해당 이벤트는 앱스토어와 무관합니다.</dd>
							<dd>
								당첨자는 펫룸 &gt; 알림 &gt; 선물함 &gt; ‘받기'를 통해서 상품을
								받으실 수 있습니다
							</dd>
							<dd>이벤트 기프티콘 상품은 교환/환불/연장이 불가합니다.</dd>
							<dd>
								지급된 상품은 30일 내로 ‘받기'를 해주셔야 정상 수령됩니다.
							</dd>
						</dl>
					</div>

					{/* 비글즈앱 다운로드 */}
					<a
						href={getDownloadLink()}
						target='_blank'
						rel='noopener noreferrer'
						className='btn-download'
					>
						<i></i>앱 다운로드 하러가기
					</a>
				</div>
			</div>
		</div>
	);
};

export default InteriorItemPromotion;
